var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-anchor",attrs:{"id":_vm.safeId,"breadcrumb-title":_vm.title,"breadcrumb-link-class":_vm.linkClass}},[_vm._t("default",[_c('h2',[_vm._v(_vm._s(_vm.title))])])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11eb070a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/BreadcrumbAnchor.vue
// module id = 75
// module chunks = 0 1 2 3 4 5 6 10 12